import React, { useMemo } from "react";

import Email from "@mapmycustomers/shared/types/email/Email";

import sanitizeEmailHtml from "@app/util/email/sanitizeEmailHtml";

interface SentEmailBodyProps {
  body: Email["body"];
  className?: string;
}

const SentEmailBody = ({ body, className }: SentEmailBodyProps) => {
  // Email body is attacker-controlled HTML — sanitize before dangerouslySetInnerHTML.
  const sanitized = useMemo(() => sanitizeEmailHtml(body), [body]);
  return <div className={className} dangerouslySetInnerHTML={{ __html: sanitized }} />;
};

export default SentEmailBody;
